<template>
    <transition name="toggleContentComponent">
        <article class="pdfViewerTemplate" v-if="ready">
            <iframe v-show="isFullScreen" class="pdfContainer" ref="pdf" :src="getMediaPath(properties.pdf?.src)"
                :style="invertedScaleStyles" @click.stop></iframe>
            <div v-show="!isFullScreen" class="preview">
                <div class="media">
                    <img v-if="properties.image" :src="getMediaPath(properties.image?.src)"
                        :alt="properties.image?.name">
                </div>
                <div class="text-container small background-gradient">
                    <h2>{{ properties?.title }}</h2>
                    <div class="scroll-container" v-html="properties?.description"></div>
                    <button class="button button--file" @click="onFullScreenClick()">
                        <div class="icon"></div>
                        <span>Open file</span>
                    </button>
                </div>
                <button class="fullscreenVideo__close" @click="closeComponent"></button>

            </div>
        </article>
    </transition>
</template>

<script>
import ShareButton from '../../ui/ShareButton.vue'

export default {
    props: ['properties', 'slug'],
    data() {
        return {
            ready: false,
            isFullScreen: this.properties.image ? false : true,
        }
    },
    mounted() {
        this.ready = true;
    },
    methods: {
        closeComponent() {
            this.$store.dispatch('showLogo');
            this.$emit("closeComponent", this.slug)
        },
        getMediaPath(src) {
            return app.api.Utils.getMediaPath(src)
        },
        onFullScreenClick() {
            this.$store.dispatch('hideLogo');
            this.isFullScreen = true
        }
    },
    computed: {
        invertedScaleStyles() {
            // lets iframe content scale to always be 1! - despite any TK scale
            var currentScale = this.$store.getters.getScaleValue;
            var invertedScale = 1 / currentScale;
            var initScale = 100;

            return {
                'transform': `scale(${invertedScale})`,
                'height': `calc(${currentScale * initScale}% + 1px)`,
                'width': `calc(${currentScale * 100}% + 1px)`
            }
        }
    }
}
</script>

<style lang="scss">
.pdfViewerTemplate {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    // background-color: rgba($color: #000000, $alpha: .6);

    .preview {
        position: relative;
        width: 80%;
        height: 800px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin-top: 32px;

        .media {
            overflow: hidden;
        }

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
            object-position: center;
        }

        // open PDF button
        .button--file {
            position: absolute;
            bottom: 45px;
        }

        .fullscreenVideo__close {
            position: absolute;
            left: 100%;
            top: 0;
            height: 60px;
            width: 60px;
            background: var(--main-color);
            background-image: url(@/assets/img/ui/close.svg);
            background-position: center;
            background-repeat: no-repeat;
        }
    }

    .pdfContainer {
        position: absolute;
        z-index: 1;
        border: none;
    }
}
</style>